import { connect } from 'react-redux';
import { compose } from 'redux';
import { withContext, getContext, withHandlers } from 'recompose'
import PropTypes from 'prop-types'

import { getAnswer, formatId } from '../actions'

import ControlledComponent from '../components/Dimension'

const withStore = compose(
    withContext({ store: PropTypes.object }, () => {}),
    getContext({ store: PropTypes.object }),
  )

function mapStateToProps(state,ownProps) {

    const { selectedAssessment, selectedActivity, dimensionAnswer, errorMessage } = state
    const { cpId, dimensionId } = ownProps
    const { indicatorId } = dimensionAnswer[formatId(cpId,dimensionId)] || { indicatorId: '' } 

    return {
        parentId: {
            assessmentId: selectedAssessment.id,
            activityId: selectedActivity.id
        },
        answerId: indicatorId,
        errorMessage

    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    
    return {
        fetchAnswersIfNeeded: (parentId, cpId,dimensionId) => {
            dispatch(getAnswer(parentId,cpId,dimensionId))
        }
    }
}


export default compose(
    withStore,
    connect(
        mapStateToProps,
        mapDispatchToProps)
)(ControlledComponent)


// WEBPACK FOOTER //
// ./src/activities/containers/Dimension.js